import { type FC } from 'react';
import { graphql, useFragment } from 'react-relay';

import { PdpSharedBuyItNowButton } from './PdpSharedBuyItNowButton';
import { PdpSharedAddToCartButton } from './PdpSharedAddToCartButton';

import { type PdpSharedShoppingButtons_user$key } from './__generated__/PdpSharedShoppingButtons_user.graphql';
import { type PdpSharedShoppingButtons_item$key } from './__generated__/PdpSharedShoppingButtons_item.graphql';

const userFragment = graphql`
    fragment PdpSharedShoppingButtons_user on User {
        ...PdpSharedAddToCartButton_user
    }
`;

const itemFragment = graphql`
    fragment PdpSharedShoppingButtons_item on Item {
        ...PdpSharedBuyItNowButton_item
        ...PdpSharedAddToCartButton_item
    }
`;

export const PdpSharedShoppingButtons: FC<{
    user: PdpSharedShoppingButtons_user$key | null | undefined;
    item: PdpSharedShoppingButtons_item$key;
    skuId?: string;
    quantitySelected?: string;
}> = ({ user: userRef, item: itemRef, skuId, quantitySelected }) => {
    const user = useFragment(userFragment, userRef);
    const item = useFragment(itemFragment, itemRef);

    return (
        <>
            <PdpSharedBuyItNowButton
                item={item}
                skuId={skuId}
                quantitySelected={quantitySelected}
            />
            <PdpSharedAddToCartButton
                user={user}
                item={item}
                skuId={skuId}
                quantitySelected={quantitySelected}
            />
        </>
    );
};
